import { render, staticRenderFns } from "./row-practitioner-view.vue?vue&type=template&id=4144ab53&"
import script from "./row-practitioner-view.vue?vue&type=script&lang=js&"
export * from "./row-practitioner-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports